(() => {
  const popup = document.querySelector('[data-aa-candy-popup]');
  if (!popup) return;

    const winningAnswer = Number(popup.dataset.winningAnswer || 287);
  // Version the dismissal key so this campaign is not hidden by an older popup test.
  const storageKey = `aaCandyPopup:v2:${popup.id}`;
  const resultKey = `${storageKey}:result`;
  const form = popup.closest('form');
  const guess = popup.querySelector('[data-aa-candy-guess]');
  const tags = popup.querySelector('[data-aa-candy-tags]');
  const note = popup.querySelector('[data-aa-candy-note]');
  const resultHeading = popup.querySelector('[data-aa-candy-result-heading]');
  const resultText = popup.querySelector('[data-aa-candy-result-text]');
  let previousFocus = null;

  const canStore = (() => {
    try {
      localStorage.setItem(`${storageKey}:test`, '1');
      localStorage.removeItem(`${storageKey}:test`);
      return true;
    } catch (_) {
      return false;
    }
  })();

  const open = () => {
    previousFocus = document.activeElement;
    popup.hidden = false;
    document.body.classList.add('aa-candy-popup-open');
    requestAnimationFrame(() => (guess || popup.querySelector('button'))?.focus());
  };

  const close = () => {
    popup.hidden = true;
    document.body.classList.remove('aa-candy-popup-open');
    if (canStore) {
      const days = Number(popup.dataset.hideDays || 7);
      localStorage.setItem(storageKey, String(Date.now() + days * 86400000));
    }
    previousFocus?.focus?.();
  };

  popup.querySelectorAll('[data-aa-candy-close]').forEach((button) => button.addEventListener('click', close));
  popup.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') close();
  });

  const readStoredResult = () => {
    if (!canStore) return null;
    try {
      return JSON.parse(sessionStorage.getItem(resultKey) || 'null');
    } catch (_) {
      return null;
    }
  };

  const renderResult = (result) => {
    if (!resultHeading || !resultText || !result) return;

    if (result.isWinner) {
      resultHeading.textContent = 'You got it — congratulations!';
      resultText.textContent = '287 is the winning number. We’ll contact you by email with the next steps after we verify your entry.';
      return;
    }

    resultHeading.textContent = 'Sorry, not this time.';
    resultText.textContent = 'Your guess wasn’t the winning number. Better luck next time — and keep an eye on your inbox for a little thank-you from us.';
  };

  form?.addEventListener('submit', () => {
    const cleanGuess = String(guess?.value || '').replace(/\D/g, '').slice(0, 4);
    if (!cleanGuess) return;

    const isWinner = Number(cleanGuess) === winningAnswer;
    const resultTag = isWinner ? 'aa-candy-winner' : 'aa-candy-lost';
    if (tags) tags.value = `newsletter,aa-candy-giveaway,${resultTag},aa-candy-guess-${cleanGuess}`;
    if (note) note.value = `Candy jar guess: ${cleanGuess}. Result: ${isWinner ? 'winner' : 'not the winning number'}.`;

    if (canStore) {
      sessionStorage.setItem(resultKey, JSON.stringify({ guess: cleanGuess, isWinner }));
    }
  });

  const hiddenUntil = canStore ? Number(localStorage.getItem(storageKey) || 0) : 0;
  if (popup.dataset.submitted === 'true') {
    renderResult(readStoredResult());
    open();
  } else if (Date.now() >= hiddenUntil && !window.Shopify?.designMode) {
    window.setTimeout(open, Number(popup.dataset.delay || 4000));
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.contains(popup) || event.target === popup) open();
  });
})();
